const home = {
  hero: {
    pillBadge: "Πρωτοποριακή Οδοντιατρική Κλινική στη Βουλγαρία",
    title: {
      prefix: "Μεταμορφώνουμε Χαμόγελα,",
      emphasis: "Μεταμορφώνουμε Ζωές",
    },
    description:
      "Ζήστε κορυφαία οδοντιατρική φροντίδα με την ομάδα των εξειδικευμένων επαγγελματιών μας. Συνδυάζουμε προηγμένη τεχνολογία με εξατομικευμένα θεραπευτικά πλάνα για να σας χαρίσουμε το τέλειο χαμόγελο που σας αξίζει.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Υπηρεσίες",
    },
    specialOffer: {
      guaranteeLabel: "10 ΧΡΟΝΙΑ ΕΓΓΥΗΣΗ",
      price: "1990 €",
      priceLabel: "All on 4",
      bullets: [
        "Premium Ποιότητα",
        "Ολοκληρωμένη Λύση",
        "Εξειδικευμένη Φροντίδα",
        "Δωρεάν Συμβουλές",
      ],
    },
    floatingStats: {
      experience: { small: "Χρόνια", large: "Εμπειρίας" },
      patients: { small: "Ευχαριστημένοι", large: "Ασθενείς" },
    },
  },
  about: {
    title: "ΣΧΕΤΙΚΑ ΜΕ ΕΜΑΣ",
    description: "Αφοσιωμένοι στην παροχή εξαιρετικής οδοντιατρικής φροντίδας",
    imageAlt: "Elite Dental Solutions x-ray technology",
    badges: ["Προηγμένη Τεχνολογία", "Εξειδικευμένη Ομάδα"],
    paragraphs: [
      "Καλώς ήρθατε στην Elite Dental Solutions, μια κορυφαία οδοντιατρική κλινική με έδρα τη Σόφια της Βουλγαρίας. Η ομάδα μας, αποτελούμενη από έμπειρους και εξειδικευμένους οδοντιάτρους και οδοντοτεχνίτες με πάνω από 10 χρόνια εμπειρίας, είναι αφοσιωμένη στην παροχή εξαιρετικής φροντίδας σε ντόπιους και διεθνείς ασθενείς.",
      "Είμαστε περήφανοι που χρησιμοποιούμε τις πιο σύγχρονες τεχνολογίες στον τομέα της οδοντιατρικής για να εξασφαλίσουμε την καλύτερη δυνατή φροντίδα για τους ασθενείς μας. Με περισσότερες από 50 πιστοποιήσεις και εκτενή εμπειρία στη συνεργασία με διεθνείς ασθενείς, προσφέρουμε μια ολοκληρωμένη γκάμα οδοντιατρικών υπηρεσιών για να καλύψουμε κάθε σας ανάγκη και να σας βοηθήσουμε να αποκτήσετε ένα όμορφο χαμόγελο.",
    ],
    checkBullets: [
      "Υπερσύγχρονος εξοπλισμός και τεχνολογία",
      "Πολύγλωσσο προσωπικό για διεθνείς ασθενείς",
      "Εξατομικευμένα θεραπευτικά πλάνα για κάθε ασθενή",
      "Ολοκληρωμένες υπηρεσίες οδοντιατρικού τουρισμού",
    ],
    cta: "Κλείσιμο Ραντεβού",
    stats: [
      {
        value: "10+",
        title: "Χρόνια Εμπειρίας",
        description: "Περισσότερο από μία δεκαετία εξαιρετικής φροντίδας",
      },
      {
        value: "5000+",
        title: "Χαμογελαστοί Ασθενείς",
        description: "Ικανοποιημένοι ασθενείς από όλο τον κόσμο",
      },
      {
        value: "20+",
        title: "Εξειδικευμένες Πιστοποιήσεις",
        description: "Υψηλά καταρτισμένοι επαγγελματίες οδοντίατροι",
      },
      {
        value: "12+",
        title: "Ευχαριστημένα Μέλη Προσωπικού",
        description: "Αφοσιωμένη ομάδα εξειδικευμένων οδοντιάτρων",
      },
    ],
  },
  services: {
    heading: "ΟΙ ΥΠΗΡΕΣΙΕΣ ΜΑΣ",
    description: "Ολοκληρωμένη οδοντιατρική φροντίδα και εξατομικευμένη προσέγγιση",
    learnMore: "Μάθετε περισσότερα",
    contactCta: "Μάθετε περισσότερα",
    items: {
      implantology: {
        title: "ΕΜΦΥΤΕΥΜΑΤΟΛΟΓΙΑ",
        description:
          "Η κλινική μας προσφέρει υψηλής ποιότητας και μακροχρόνιες αντικαταστάσεις δοντιών, οι οποίες εγγυώνται φυσική εμφάνιση και αίσθηση. Εναρμονίζονται απόλυτα με τα φυσικά σας δόντια και βελτιώνουν σημαντικά τη στοματική σας υγεία.",
        imageAlt: "Implantology",
      },
      endodontics: {
        title: "ΕΝΔΟΔΟΝΤΙΑ",
        description:
          "Στην κλινική μας εφαρμόζουμε θεραπείες απονεύρωσης με φιλικές προς τον ασθενή μεθόδους. Έτσι, ελαχιστοποιούμε την ενόχληση και διατηρούμε τη φυσική ομορφιά του χαμόγελού σας, ενώ ταυτόχρονα αποκαθιστούμε τη λειτουργία και την υγεία των κατεστραμμένων ή μολυσμένων δοντιών.",
        imageAlt: "Endodontics",
      },
      "oral-surgery": {
        title: "ΧΕΙΡΟΥΡΓΙΚΗ ΣΤΟΜΑΤΟΣ",
        description:
          "Η κλινική μας προσφέρει ελάχιστα επεμβατικές εξαγωγές καθώς και ολοκληρωμένη θεραπεία για μια σειρά από στοματικά και γναθοπροσωπικά προβλήματα, με έμφαση στην αποκατάσταση της στοματικής υγείας, την άνεση του ασθενούς και την αισθητική.",
        imageAlt: "Oral Surgery",
      },
      periodontology: {
        title: "ΠΕΡΙΟΔΟΝΤΟΛΟΓΙΑ",
        description:
          "Η κλινική μας προσφέρει εξειδικευμένες θεραπείες και φροντίδα για τα ούλα, με έμφαση στην πρόληψη, διάγνωση και αντιμετώπιση της περιοδοντικής νόσου, συμβάλλοντας στη βελτίωση της στοματικής υγείας και της γενικής ευεξίας.",
        imageAlt: "Periodontology",
      },
      orthodontics: {
        title: "ΟΡΘΟΔΟΝΤΙΚΗ",
        description:
          "Στην κλινική μας προσφέρουμε εξειδικευμένες θεραπείες για μη ευθυγραμμισμένα δόντια. Χρησιμοποιούμε προηγμένες μεθόδους και κάθε θεραπευτικό πλάνο είναι πλήρως εξατομικευμένο, ώστε να εξασφαλίσουμε το καλύτερο δυνατό αποτέλεσμα για τους ασθενείς μας — βελτιώνοντας τόσο την εμφάνιση όσο και τη στοματική τους υγεία.",
        imageAlt: "Orthodontics",
      },
      bonding: {
        title: "ΟΨΕΙΣ ΡΗΤΙΝΗΣ (BONDING)",
        description:
          "Στην κλινική μας εφαρμόζουμε με εξειδίκευση ρητίνη στο χρώμα των φυσικών δοντιών, με σκοπό να βελτιώσουμε την αισθητική τους. Για ένα αρμονικό και εντυπωσιακό αποτέλεσμα που ενισχύει την αυτοπεποίθησή σας και το χαμόγελό σας, προσαρμόζουμε τη ρητίνη ώστε να ταιριάζει απόλυτα με το φυσικό χρώμα των δοντιών σας.",
        imageAlt: "Bonding",
      },
      prosthetics: {
        title: "ΠΡΟΣΘΕΤΙΚΗ",
        description:
          "Το οδοντιατρικό μας κέντρο εξειδικεύεται στην παροχή λύσεων για την αντικατάσταση χαμένων δοντιών, χρησιμοποιώντας εξατομικευμένες γέφυρες ή οδοντοστοιχίες. Αυτές οι προσθετικές κατασκευές σχεδιάζονται με προσοχή, όχι μόνο για να αποκαταστήσουν τη λειτουργικότητα, αλλά και για να ενισχύσουν την αισθητική του χαμόγελού σας.",
        imageAlt: "Prosthetics",
      },
      cariesology: {
        title: "ΤΕΡΗΔΟΝΟΛΟΓΙΑ",
        description:
          "Προσφέρουμε ολοκληρωμένη πρόληψη και στοχευμένη θεραπεία για την τερηδόνα, τακτικούς ελέγχους και προηγμένη διαγνωστική τεχνολογία, ώστε να διασφαλίζουμε αποτελεσματική φροντίδα και μακροχρόνια στοματική υγεία.",
        imageAlt: "Cariesology",
      },
      "teeth-whitening": {
        title: "ΛΕΥΚΑΝΣΗ ΔΟΝΤΙΩΝ",
        description:
          "Αποκτήστε ένα πιο λαμπερό και νεανικό χαμόγελο καθώς αφαιρούμε με επιδεξιότητα λεκέδες και αποχρωματισμούς από τα δόντια σας. Οι θεραπείες μας είναι σχεδιασμένες για να ενισχύουν την οδοντική αισθητική, προσφέροντάς σας ένα εκθαμβωτικό χαμόγελο.",
        imageAlt: "Teeth Whitening",
      },
      "dental-tourism": {
        title: "ΟΔΟΝΤΙΑΤΡΙΚΟΣ ΤΟΥΡΙΣΜΟΣ",
        description:
          "Μετάφραση, μεταφορά και βοήθεια για τη διαμονή — απλώς κλείστε ραντεβού μαζί μας και η αφοσιωμένη ομάδα μας θα φροντίσει κάθε λεπτομέρεια, προσφέροντάς σας μια ομαλή εμπειρία, προσαρμοσμένη στις ανάγκες σας.",
        imageAlt: "Dental Tourism",
      },
    },
  },
  testimonials: {
    heading: "ΕΥΧΑΡΙΣΤΗΜΕΝΟΙ ΑΣΘΕΝΕΙΣ",
    subheading: "Δείτε τι λένε οι ασθενείς μας για την εμπειρία τους κοντά μας",
    google: {
      title: "Google Reviews",
      ratingValue: "5.0",
      countLabel: "(63 reviews)",
      readAll: "Διαβάστε όλες τις αξιολογήσεις",
    },
    carousel: {
      prevAria: "Previous testimonial",
      nextAria: "Next testimonial",
    },
    metrics: {
      satisfaction: "Ποσοστό Ικανοποίησης",
      positive: "Θετικές Αξιολογήσεις",
      countries: "Χώρες Εξυπηρέτησης",
    },
    items: {
      google: {
        g1: {
          content:
            "Nothing short of perfect will do for this Clinic. Their attention to detail is second to none. The staff are so professional yet caring. English is widely spoken by all.",
          name: "Garry Gariside",
          timeAgo: "4 weeks ago",
          initial: "G",
        },
        g2: {
          content:
            "I had the immense pleasure of receiving treatment at Elite Dental Solutions under the care of Dr. Hadzhialish, and I couldn't be more thrilled with the results. I opted for the All-on-4 implant procedure, and from the very beginning, I felt in safe hands.",
          name: "Olen Sr12",
          timeAgo: "2 months ago",
          initial: "O",
        },
        g3: {
          content:
            "The clinic was immaculate. Doctors friendly and efficient. Very happy with the results. Couldn't have been looked after better.",
          name: "Loz Borg",
          timeAgo: "3 months ago",
          initial: "L",
        },
      },
      regular: {
        r1: {
          content:
            "I was nervous about getting dental implants, but the team at Elite Dental Solutions made the entire process smooth and stress-free. From my first consultation to the final result, they were professional, caring, and attentive. I now have a beautiful smile that I'm proud of, and I couldn't be happier with the outcome!",
          name: "Lynn M",
          location: "United Kingdom",
        },
        r2: {
          content:
            "I visited Elite Dental Solutions for teeth whitening before my wedding, and the results were incredible! The staff was so friendly, and they really took the time to explain the procedure to me. My teeth are several shades brighter, and I felt so confident on my big day. Thank you for making my smile picture-perfect!",
          name: "George L",
          location: "Germany",
        },
        r3: {
          content:
            "After years of dealing with tooth sensitivity and gum issues, I finally found the solution at Elite Dental Solutions. Their thorough approach to my treatment and the personalized care I received made all the difference. I can eat and smile without pain now, and I'm so grateful for their expertise and kindness.",
          name: "Alex D",
          location: "Italy",
        },
        r4: {
          content:
            "Having avoided dental work for years due to anxiety, I was amazed by how comfortable the team at Elite Dental Solutions made me feel. They were patient, understanding, and explained everything clearly. The quality of work is outstanding, and for the first time in my life, I don't dread going to the dentist!",
          name: "Sarah K",
          location: "France",
        },
        r5: {
          content:
            "As someone who traveled from abroad specifically for dental work, I couldn't be more impressed with Elite Dental Solutions. They arranged everything from airport pickup to accommodation recommendations. The dental work itself was top-notch, and the cost savings compared to my home country made the trip more than worthwhile.",
          name: "James W",
          location: "United States",
        },
      },
    },
  },
  gallery: {
    heading: "ΦΩΤΟΓΡΑΦΙΚΟ ΥΛΙΚΟ",
    subheading: "Ανακαλύψτε τη συλλογή μας με εντυπωσιακές μεταμορφώσεις χαμογελων",
    closeAria: "Close gallery",
    prevAria: "Previous image",
    nextAria: "Next image",
    items: {
      i1: { alt: "Εσωτερικοί χώροι της κλινικής Elite Dental Solutions", category: "Κλινική" },
      i3: { alt: "Υπερσύγχρονος οδοντιατρικός εξοπλισμός", category: "Εξοπλισμός" },
      i4: { alt: "Προηγμένη οδοντιατρική τεχνολογία", category: "Εξοπλισμός" },
      i5: { alt: "Αίθουσα οδοντιατρικής", category: "Κλινική" },
      i6: { alt: "Χώρος υποδοχής οδοντιατρικής κλινικής", category: "Κλινική" },
      i7: { alt: "Προηγμένη τεχνολογία οδοντιατρικών ακτινογραφιών", category: "Τεχνολογία" },
      i8: { alt: "Περιβάλλον οδοντιατρικής πρακτικής", category: "Κλινική" },
      i9: { alt: "Σύγχρονες οδοντιατρικές εγκαταστάσεις", category: "Κλινική" },
      i10: { alt: "Προηγμένος οδοντιατρικός χώρος εργασίας", category: "Εξοπλισμός" },
      i11: { alt: "Επαγγελματικός οδοντιατρικός εξοπλισμός", category: "Εξοπλισμός" },
      i12: { alt: "Υπερσύγχρονο οδοντατρείο", category: "Κλινική" },
    },
  },
  contact: {
    heading: "ΕΠΙΚΟΙΝΩΝΗΣΤΕ ΜΑΖΙ ΜΑΣ",
    subheading: "Είμαστε εδώ για να απαντήσουμε στις ερωτήσεις σας και να σας βοηθήσουμε να προγραμματίσετε την επίσκεψή σας",
    cardTitle: "Επικοινωνήστε Μαζί Μας",
    labels: {
      phone: "Τηλέφωνο",
      email: "Email",
      address: "Διεύθυνση",
      workingHours: "Ώρες Λειτουργίας",
    },
    phone: { telHref: "+359879800430", display: "+359 879 800 430" },
    email: { value: "info@elitedentalsolutions.eu" },
    address: {
      line1: "Manastirski Livadi, zh.k. Manastirski livadi B 65,",
      line2: "1404 Σόφια, Βουλγαρία",
    },
    workingHours: {
      line1: "Δευτέρα - Παρασκευή: 9:00 - 19:00",
      line2: "Σάββατο: Κατόπιν ραντεβού",
    },
    stickyCallText: "Call Now",
    form: {
      title: "Φόρμα Επικοινωνίας",
    },
  },
  contactForm: {
    fieldLabels: {
      firstName: "Όνομα*",
      lastName: "Επώνυμο*",
      email: "Email*",
      phone: "Τηλέφωνο*",
      message: "Μήνυμα*",
    },
    errors: {
      firstNameRequired: "First Name is required",
      lastNameRequired: "Last Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Invalid phone number",
    },
    toasts: {
      validationError: {
        title: "Validation Error",
        description: "Please fill in all required fields correctly.",
      },
      success: {
        title: "Message Sent!",
        description: "We'll get back to you as soon as possible.",
      },
      error: {
        title: "Error",
        description: "Failed to send message. Please try again later.",
      },
    },
    submit: {
      idle: "Αποστολή",
      loading: "Αποστολή...",
    },
    privacy: {
      prefix: "Με την υποβολή αυτής της φόρμας, συμφωνείτε με την",
      linkLabel: "Πολιτική Απορρήτου",
      suffix: " μας.",
    },
  },
};

export default home;

